import { FormError, StyledLabel } from 'components/organisms/FormsSlice/Forms/Forms';
import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';
import {
  ArrowStyled,
  CurrentStyled,
  SelectContainerStyled,
  SelectStyled,
  Wrapper,
} from './SelectInput.styles';
import { SelectInputProps, Option } from './SelectInput.types';

export const SelectInput: React.FC<SelectInputProps> = ({
  className,
  options,
  name,
  label,
  placeholder,
  register,
  hasError,
  errorMessageRequired,
  validationOptions,
  defaultValue,
}) => {
  const { t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<Option | null>(
    defaultValue ? options.find((o) => o.value === defaultValue) || null : null
  );

  function switchOpen() {
    setIsOpen((prevState) => !prevState);
  }

  const emptyOptionValue = '';
  const registerProps = register(name, validationOptions);

  return (
    <>
      <StyledLabel htmlFor={name}>{t(label)}</StyledLabel>
      <Wrapper className={className} id="cta-dropdown" hasError={hasError}>
        <CurrentStyled id={name}>
          {selectedOption ? selectedOption.label : t(placeholder)}
          <ArrowStyled isOpen={isOpen} />
        </CurrentStyled>

        <SelectContainerStyled>
          <SelectStyled
            {...registerProps}
            onClick={switchOpen}
            hasError={hasError}
            defaultValue={defaultValue || ''}
            onChange={(e) => {
              // Spreading registerProps installs react-hook-form's own onChange,
              // but this prop overrides it — so RHF has to be notified by hand or
              // the field stays unset and required-validation fails on a filled form.
              registerProps.onChange(e);

              const selectedOption = options.find((option) => option.value === e.target.value);
              setSelectedOption(selectedOption || null);
            }}
          >
            <option value={selectedOption?.value}>{emptyOptionValue}</option>
            {options?.map((option) => (
              <option key={`cta-option_${option.label}`} value={String(option.value)}>
                {option.label}
              </option>
            ))}
          </SelectStyled>
        </SelectContainerStyled>
      </Wrapper>
      {hasError && errorMessageRequired && <FormError>{t(errorMessageRequired)}</FormError>}
    </>
  );
};
